import { Toaster } from 'react-hot-toast';

/**
 * Toast Provider Component
 * Wraps the app to provide toast notifications with pill-shaped design
 */

const ToastProvider = ({ children }) => {
  return (
    <>
      {children}
      <Toaster
        position="top-right"
        reverseOrder={false}
        gutter={12}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          // Default options - pill-shaped design with orange primary color
          className: '',
          duration: 4000,
          style: {
            background: '#FFF5E6', // primary-50
            color: '#663700', // primary-900
            padding: '12px 16px',
            borderRadius: '9999px', // Full rounded for pill shape
            boxShadow:
              '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            maxWidth: '420px',
            minWidth: '280px',
            border: '1px solid #FFD699', // primary-200
            fontSize: '14px',
            fontWeight: '500',
          },

          // Specific toast types
          success: {
            duration: 4000,
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
            style: {
              background: '#ECFDF5',
              color: '#065F46',
              border: '1px solid #A7F3D0',
            },
          },
          error: {
            duration: 5000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
            style: {
              background: '#FEF2F2',
              color: '#991B1B',
              border: '1px solid #FECACA',
            },
          },
          loading: {
            duration: Infinity,
            iconTheme: {
              primary: '#FF9F43', // primary-500
              secondary: '#fff',
            },
            style: {
              background: '#FFF5E6', // primary-50
              color: '#663700', // primary-900
              border: '1px solid #FFD699', // primary-200
            },
          },
        }}
      />
    </>
  );
};

export default ToastProvider;
